import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  PM_TICKET,
  PM_TICKET_DETAILS,
  PM_ASSIGNEE,
  PM_TICKET_STATUS,
  PM_TICKET_ASSIGNEE,
  PM_TICKET_FILTER,
  PM_SLOT_DETAILS,
  PROJECT_PM_TICKET_DETAILS
} from './type';
import { daDK } from 'rsuite/esm/locales';

export const fetchPmTicket = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.maintenance.fetchPMTickets}?page=${page}`
      : `${Config.maintenance.fetchPMTickets}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_TICKET,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmTicketDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.PMTicketDetails}?pm_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_TICKET_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmAssignee = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchUserAssignee}?pm_ticket_id=${id}`
  );

  if (res) {
    const { data } = res;
    dispatch({
      type: PM_ASSIGNEE,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmTicketAssignee = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmTicketAssignee}?scehdule_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_TICKET_ASSIGNEE,
      payload: data.response.data,
    });
    return true;
  }
};

export const postSchedulePM = (site_id, maintenanceDate, assigneeId, slot) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.maintenance.storeSchedulePM}?pm_site_id=${site_id}&maintenance_date=${maintenanceDate}&assignee_id=${assigneeId}&slot=${slot}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postScheduleProjectPM = (formData) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    {"data":formData},
    `${Config.maintenance.storeScheduleProjectPM}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postUpdatePMStatus = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.pmticketUpdateStatus}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postRemarks = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.postRemarks}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postTicketAssignment = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.ticketAssignment}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const fetchPmTicketStatus = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmTicketStatus}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_TICKET_STATUS,
      payload: data.response.data,
    });
    return true;
  }
};

export const getPmTicketsFilterDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmTicketsFilters}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_TICKET_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmSlotDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchPmSlotDetails}?pm_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SLOT_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchProjectPmSlotDetails = (site_id=null,id=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchProjectPmSlotDetails}?site_id=${site_id}&pm_ticket_id=${id}`
  );
  
  if (res) {
    const { data } = res;
    dispatch({
      type: PROJECT_PM_TICKET_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};
